import { Button } from '@ytl/common-web';
import LockedOutImage from '../../assets/lockedout.svg';
import { useLanguage } from '../../contexts/languageContext';
import { useMigration } from './service/MigrationContext';

/**
 * LockoutView - Desktop/Web verzió
 * Megjelenik, ha a felhasználó túl sokszor próbálkozott sikertelenül
 */
export const LockoutView = () => {
  const { translation } = useLanguage();
  const { handleReturnToApp } = useMigration();

  return (
    <div className="migra-first-page-wrapper">
      <div className="migra-first-page">
        <div className="migra-first-page__container">
          <div className="migra-first-page__content">
            <h3>{translation.migra.lockout.header}</h3>
            <p>{translation.migra.lockout.description}</p>
            <Button
              variant="contained"
              onClick={handleReturnToApp}
            >
              {translation.migra.lockout.exitButton}
            </Button>
          </div>
          <div className="migra-first-page__illustration">
            <img
              src={LockedOutImage}
              alt="Locked out"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
